import React from 'react'
import styled from 'styled-components'
import { Grid, Input } from 'semantic-ui-react'
import isEqual from 'lodash/isEqual'
import includes from 'lodash/includes'
import uniqueId from 'lodash/uniqueId'

import LKGrid from 'shared/LKGrid'
import { GridContainer, ComponentContainer } from 'shared/StyledComponents'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .search-grid__container {
    flex: 1;
    margin-top: 5px;
  }
`

class LocalSearchGrid extends React.PureComponent {
  state = {
    filtered: null,
    gridIndex: null,
  }

  handleInputChange = (event) => {
    const { searchBy, data, onInputChange } = this.props
    const searchValue = event.target.value.toLowerCase()

    const filtered = data.filter((row) => includes(row[searchBy].toLowerCase(), searchValue))

    onInputChange(filtered)

    if (!isEqual(this.state.filtered, filtered)) {
      this.setState({ filtered, gridIndex: uniqueId('local_search') })
    }
  }

  render() {
    const { children, LKGridConfig, ...rest } = this.props
    const { gridIndex } = this.state

    const filtered = this.state.filtered || this.props.data

    return (
      <Wrapper>
        <GridContainer noRowPadding>
          <Grid>
            <Grid.Row>
              <Grid.Column width={10}>{children}</Grid.Column>

              <Grid.Column width={6}>
                <ComponentContainer className="u-marginTop-10" input>
                  <Input fluid onChange={this.handleInputChange} />
                </ComponentContainer>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <div className="search-grid__container">
          <LKGrid key={gridIndex} rowData={filtered} {...LKGridConfig} {...rest} />
        </div>
      </Wrapper>
    )
  }
}

export default LocalSearchGrid
